import { TableFilterSelectOption } from '@aibees/elephant/components/table-filter-select';
import { ElephantPresetType } from '@aibees/elephant/types';
import { useMemo } from 'react';
import {
  SavedSearchCountsFilters,
  useSavedSearchCounts,
} from './use-saved-search-counts';

const ALL_KEY = `${ElephantPresetType.COMPANY_SAVED_SEARCH},${ElephantPresetType.PEOPLE_SAVED_SEARCH}`;

/**
 * Decorates the saved-search type options (All Types / Company / People) with
 * their real totals. Pass the table's live `filters` so the numbers follow the
 * search text and the active All / Mine / Team tab.
 *
 * Options are returned untouched while the counts are still loading, so the
 * dropdown shows no number rather than a misleading 0.
 */
export function useAddSavedSearchTypeMetadata(
  options: TableFilterSelectOption[],
  filters?: SavedSearchCountsFilters
) {
  const { byType } = useSavedSearchCounts(filters);

  return useMemo(() => {
    if (!byType) return options;

    return options.map((o) => {
      if (o.key === ALL_KEY) return { ...o, metadata: byType.all };
      if (o.key === ElephantPresetType.COMPANY_SAVED_SEARCH) {
        return { ...o, metadata: byType.company };
      }
      if (o.key === ElephantPresetType.PEOPLE_SAVED_SEARCH) {
        return { ...o, metadata: byType.people };
      }
      return o;
    });
  }, [byType, options]);
}
